import {LinearProgress, makeStyles} from "@material-ui/core";
import * as React from "react";
import {LinearProgressProps} from "@material-ui/core/LinearProgress/LinearProgress";
import clsx from "clsx";
import {ProgressBarStyle} from './progressBar.style';


const useStyles = makeStyles(ProgressBarStyle);

const ProgressBar = (props: LinearProgressProps) => {
    const {className, classes: customClasses, ...rest} = props;
    const classes = useStyles();

        return (<LinearProgress
            variant="determinate"
            {...rest}
            color="primary"
            className={clsx(classes.root, className)}
            classes={{
                bar: classes.bar,
                barColorPrimary: classes.barColorPrimary,
                barColorSecondary: classes.barColorSecondary,
                determinate: classes.determinate,
                indeterminate: classes.indeterminate,
                ...customClasses
            }}
        />);
};

export default ProgressBar;




// WEBPACK FOOTER //
// ./src/components/common/progressBar/progressBar.tsx